export const autoSuggestHistoryKey = 'autosuggesthistory';
export var autosuggestVersion;
(function (autosuggestVersion) {
    autosuggestVersion["V3"] = "V3";
    autosuggestVersion["V4"] = "V4";
})(autosuggestVersion || (autosuggestVersion = {}));
export var ContentType;
(function (ContentType) {
    ContentType["HISTORY"] = "HISTORY";
    ContentType["TRENDING"] = "TRENDING";
})(ContentType || (ContentType = {}));
